module.exports = __webpack_public_path__ + "1.4.15-unryo/img/network.b7038a20.svg";